module.exports = __webpack_public_path__ + "static/single-family-e44829291bb580d483ed9699e419f644.png";